import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Our Magento Tech stack</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              We leverage the latest technologies that suit your project
              requirements to deliver high-performing ecommerce solutions.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Custom Storefront Development">
              <ul>
                <li>React</li>
                <li>Vue.js</li>
                <li>Next.JS</li>
                <li>Gatsby</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Mobile Apps">
              <ul>
                <li>Swift</li>
                <li>Kotlin</li>
                <li>React Native</li>
                <li>Flutter</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Storefront Customization">
              <ul>
                <li>Luma</li>
                <li>Vue Storefront</li>
                <li>PWA Studio</li>
                <li>jQuery</li>
                <li>Vue.JS</li>
                <li>React</li>
                <li>Next.JS</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Storefront Customization">
              <ul>
                <li>Amazon Web</li>
                <li>Services (AWS)</li>
                <li>Microsoft Azure</li>
                <li>Google Cloud</li>
                <li>Platform (GCP)</li>
                <li>Firebase</li>
                <li>AppCenter for CI/CD</li>
                <li>Kubernetes</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Back-End">
              <ul>
                <li>PHP</li>
                <li>end Framework</li>
                <li>Symfony</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
